import {CanActivateFn, Router} from '@angular/router';
import {inject, signal} from "@angular/core";
import {HupSubscriptionsService} from "../../data/services/hup-subscriptions.service";
import {SourceSystemName} from "../../data/models/source-system-name";
import {NavigationCommand} from "../../data/services/navigation.service";

export const terminationGuard: CanActivateFn = (route, state) => {
  const subscriptionService = inject(HupSubscriptionsService);
  const router = inject(Router);
  const backendId = route.paramMap.get('subId');
  const allowed = signal(true);
  const webId = '0';
  const delimiter = '/';
  const NAVIGATING_TO_SUBSCRIPTION_LIST_WARNING = 'Navigating to subscription list';
  const NAVIGATING_TO_SUBSCRIPTION_WITH_BACKEND_ID_WARNING = 'Navigating to subscription with backendId';
  const ERROR_WHILE_LOADING_SUBSCRIPTION_WARNING = 'Error while loading subscription with id';

  subscriptionService.getSubscription(webId, backendId).subscribe({
    next: sub => {
      if (!sub) {
        allowed.set(false);
        router.navigate([NavigationCommand.SUBSCRIPTION.toString()])
          .then(r => console.debug(NAVIGATING_TO_SUBSCRIPTION_LIST_WARNING, r))
      } else if (sub?.sourceSystem?.systemName?.toString() != SourceSystemName[SourceSystemName.WEBABO]) {
        allowed.set(false);
        router.navigate([NavigationCommand.SUBSCRIPTION.toString() + delimiter + webId + delimiter + backendId])
          .then(r => console.debug(NAVIGATING_TO_SUBSCRIPTION_WITH_BACKEND_ID_WARNING, backendId))
      }
    },
    error: () => {
      allowed.set(false);
      console.debug(ERROR_WHILE_LOADING_SUBSCRIPTION_WARNING, backendId);
      router.navigate([NavigationCommand.SUBSCRIPTION.toString()])
        .then(r => console.debug(NAVIGATING_TO_SUBSCRIPTION_LIST_WARNING, r))
    }
  });
  return allowed();
};
